import React from 'react'
import Navbar from '../elements/Navbar'
import Footer from '../elements/Footer'
import { motion } from "framer-motion";
import ContactForm from '../elements/ContactForm';

export default function ContactUsPage() {
  return (
    <div className=" grid grid-cols-1 content-between">
        <div className="sticky top-0 z-50">
          <Navbar />
        </div>
        <motion.div animate={{ y: -10 }} transition={{ duration: 0.5 }}>
          <ContactForm/>
        </motion.div>
        <Footer />
      </div>
  )
}
